import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DateTime } from 'luxon';
import { Year } from '../../models';
import { RmsUtilsService } from '../../../core/services';


/**
 * Component class for rms light carousel
 */
@Component({
    selector: 'rms-carousel',
    templateUrl: './carousel.component.html',
    styleUrls: ['./carousel.component.scss'],
    standalone: false
})
export class CarouselComponent implements OnInit, AfterViewInit {

  @Input() list: Array<Year> = [];
  @Input() initialSelectedValue: string;
  @Output() yearSelected = new EventEmitter<Year>();
  @ViewChild('carouselListRef', { static: false }) public carouselListRef: ElementRef;
  @ViewChild('carouselWrapRef', { static: true }) public carouselWrapRef: ElementRef;
  private carouselItemWidth: number;
  public listPosition: string | number;
  public carouselScrollRightEnd = false;
  public carouselScrollLeftEnd = true;

  constructor(
    private cd: ChangeDetectorRef
  ) {
    this.listPosition = 0;
  }

  ngOnInit() {
  }

  /**
   * Validates on component loads if the right carousel button should be enabled
   */
  ngAfterViewInit(): void {
    this.carouselItemWidth = this.carouselListRef.nativeElement.querySelector('li').clientWidth;
    this.validateScrollRight();
    if (this.initialSelectedValue) {
      const selected = this.list.find(item => item.year.toString().slice(-2) === this.initialSelectedValue.slice(-2));
      this.selectYear(selected);
      this.focusPreSelected();
    } else {
      this.focusPreSelected(true);
    }
  }

  /**
   * Check if the right carousel button can be enabled based on the carousel width
   */
  private validateScrollRight () {
    setTimeout(() => {
      this.carouselScrollRightEnd = this.carouselWrapRef.nativeElement.clientWidth >= this.carouselListRef.nativeElement.clientWidth;
    }, 10);
  }

  /**
   * Animate carousel position
   * @param {string} direction: where the carousel should move to/from
   */
  public updateCarouselPosition (direction: string) {
    const carouselLeftPos = Number(window.getComputedStyle(this.carouselListRef.nativeElement, null).getPropertyValue('left').slice(0, -2));
    this.listPosition = ((direction === 'prev') ? carouselLeftPos + this.carouselItemWidth : carouselLeftPos - this.carouselItemWidth) + 'px';
    this.carouselScrollLeftEnd = Number(this.listPosition.slice(0, -2)) >= 0;
    this.carouselScrollRightEnd = Number(this.listPosition.slice(0, -2)) <
      -(this.carouselListRef.nativeElement.clientWidth - this.carouselWrapRef.nativeElement.clientWidth);
    this.cd.detectChanges();
  }

  /**
   * Selects the year
   * Emits a global event to notify multiple components
   * @param {Year} year: selected item form the carousel
   */
  public selectYear (year: Year) {
    RmsUtilsService.resetSelected(this.list);
    year.selected = true;
    this.yearSelected.emit(year);
    this.cd.detectChanges();
  }

  /**
   * Detect selected date and animate years carousel to focus if required
   * @param scrollToCurrentYear
   */
  private focusPreSelected (scrollToCurrentYear?: boolean): void {
    const maxVisibleListIndexItem = 3;
    const selectedIndex = scrollToCurrentYear ?
      this.list.findIndex(item => item.year === DateTime.now().year) :
      this.list.findIndex(item => item.selected);
    if (selectedIndex > maxVisibleListIndexItem) {
      this.listPosition = `${-((selectedIndex) * this.carouselItemWidth)}px`;
      this.carouselScrollLeftEnd = false;
      this.carouselScrollRightEnd = false;
      this.cd.detectChanges();
    }
  }

}
